import { render } from "./Wizard.vue?vue&type=template&id=287ce252"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"

import "./Wizard.vue?vue&type=style&index=0&id=287ce252&lang=scss"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__